import React from 'react';
import { Box } from '@hz-design-system/web-ui';

import FEED_ITEMS_PER_PAGE from '../../../Homepage/constants/feedItemsPerPage';
import BlockSkeleton from '../../../Homepage/components/Skeleton/BlockSkeleton';
import TextSkeleton from '../../../Homepage/components/Skeleton/TextSkeleton';
import Classes from '../../../Homepage/components/Skeleton/Skeleton.module.scss';
import LSClasses from './AutosFeedsListSkeleton.module.scss';

type TFeedItemListSkeleton = {
  itemsCount?: number;
};

const FeedItemListSkeleton = ({ itemsCount = FEED_ITEMS_PER_PAGE }: TFeedItemListSkeleton) => (
  <Box as="div" name="contentCards" className={LSClasses.contentCards}>
    {Array(itemsCount)
      .fill(true)
      .map((_, index) => (
        <div className={`hz-Card ${Classes.noShadow}`} key={index}>
          <article className={`hz-StructuredListing hz-StructuredListing--vertical ${Classes.noShadow}`}>
            <div className={`hz-Image hz-StructuredListing-image ${Classes.border}`}>
              <BlockSkeleton withAnimation={true} />
            </div>
            <div className="hz-Block">
              <div className="hz-StructuredListing-title">
                <TextSkeleton />
              </div>
              <div className="hz-StructuredListing-price">
                <TextSkeleton type="short" />
              </div>
            </div>
          </article>
        </div>
      ))}
  </Box>
);

export default FeedItemListSkeleton;
